import { AppConfig } from 'config/baseConfig';

export default {
  ...require(process.env.VUE_APP_CONFIG_FILE!).default,
} as AppConfig & { gtmKey: string };
